import { SavedSearchResponse } from './saved-search.response';
import { SavedSearchState } from './saved-search.state';

/** Pure wire → state mapper for the saved-search endpoints. */

export function mapSavedSearchResponse(response: SavedSearchResponse): SavedSearchState {
  return {
    ...response,
    query: { ...response.query },
    createdAt: new Date(response.createdAt)
  };
}
